import React from "react";
import { Bell } from "lucide-react";

const Header = () => {
  return (
    <header className="h-16 w-full bg-white border-b border-slate-200 flex items-center justify-between px-6">

      {/* LEFT */}
      <div className="flex items-center gap-4">
        <div>

         <h1 className="text-xl font-semibold tracking-wide">
          Admin<span className="text-red-500 ml-1">Secure</span>
        </h1>
          <p className="text-xs text-slate-400 mt-1">
          Corporate Banking
        </p>
        </div>

      
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-6">

        {/* Notifications */}
        <button className="relative text-slate-600 hover:text-slate-800">
          <Bell size={20} />
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full" />
        </button>

        {/* User */}
        <div className="flex items-center gap-3 cursor-pointer">
          <div className="w-9 h-9 rounded-full bg-slate-800 text-white flex items-center justify-center text-sm font-semibold">
            A
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-slate-800">
              Admin User
            </p>
            <p className="text-xs text-slate-500">
              Treasury Ops
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
